import {
  APPROVAL_ACTION_UTILITY_REQUEST,
  APPROVAL_ACTION_UTILITY_REQUEST_SUCCESS,
  APPROVAL_ACTION_UTILITY_REQUEST_ERROR,
  APPROVAL_ACTION_UTILITY_REQUEST_EMPTY,
} from '../../actions.js';

const initialState = { data: null, loading: false, error: null };

const ApprovalActionUtilityRequest = (state = initialState, action) => {
  switch (action.type) {
    case APPROVAL_ACTION_UTILITY_REQUEST:
      return { ...state, loading: true, data: null, error: null };
    case APPROVAL_ACTION_UTILITY_REQUEST_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case APPROVAL_ACTION_UTILITY_REQUEST_ERROR:
      return { ...state, loading: false, error: action.payload };
    case APPROVAL_ACTION_UTILITY_REQUEST_EMPTY:
      return { ...initialState };
    default:
      return state;
  }
};

export default ApprovalActionUtilityRequest;
